import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'et-atoms-menu-item',
  imports: [],
  templateUrl: './menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
  disabled = input(false, { transform: booleanAttribute });
  clicked = output<void>();

  onClick(): void {
    if (this.disabled()) {
      return;
    }
    this.clicked.emit();
  }
}
